(function () {
  "use strict";

  var CONFIG = {
    endpoint: "https://go.magie-schmuck.de/sr/batch",
    rrwebUrl: "https://cdn.jsdelivr.net/npm/rrweb@1.1.3/dist/rrweb.min.js",
    sampleRate: 1,
    flushEveryMs: 5000,
    flushEveryEvents: 80,
    maxEventsPerBatch: 300,
    requireConsent: true,
    debug: false
  };

  var blockedPathPattern = /\/(account|accounts|checkout|checkouts|challenge)(\/|$)/i;
  var currentPath = window.location.pathname || "/";
  if (blockedPathPattern.test(currentPath)) return;

  var state = {
    started: false,
    stopRecording: null,
    events: [],
    markers: [],
    batchIndex: 0,
    sessionId: getSessionId(),
    landingUrl: sessionStorage.getItem("magie_sr_landing_url") || window.location.href,
    consentState: "unknown"
  };
  sessionStorage.setItem("magie_sr_landing_url", state.landingUrl);

  function log() {
    if (CONFIG.debug && window.console) console.log.apply(console, arguments);
  }

  function getSessionId() {
    var existing = sessionStorage.getItem("magie_sr_session_id");
    if (existing) return existing;
    var random = "";
    if (window.crypto && window.crypto.getRandomValues) {
      var bytes = new Uint8Array(16);
      window.crypto.getRandomValues(bytes);
      random = Array.prototype.map.call(bytes, function (byte) {
        return byte.toString(16).padStart(2, "0");
      }).join("");
    } else {
      random = String(Date.now()) + String(Math.random()).slice(2);
    }
    var sessionId = "sr_" + random;
    sessionStorage.setItem("magie_sr_session_id", sessionId);
    return sessionId;
  }

  function loadScript(src, onload) {
    var script = document.createElement("script");
    script.src = src;
    script.async = true;
    script.onload = onload;
    script.onerror = function () {
      log("magie session replay: failed to load rrweb");
    };
    document.head.appendChild(script);
  }

  function consentAllowsRecording() {
    var privacy = window.Shopify && window.Shopify.customerPrivacy;
    if (!privacy) {
      state.consentState = "privacy_api_unavailable";
      return !CONFIG.requireConsent;
    }
    if (typeof privacy.analyticsProcessingAllowed === "function") {
      var allowed = Boolean(privacy.analyticsProcessingAllowed());
      state.consentState = allowed ? "analytics_allowed" : "analytics_denied";
      return allowed;
    }
    state.consentState = "analytics_method_unavailable";
    return !CONFIG.requireConsent;
  }

  function waitForConsent(callback) {
    var attempts = 0;

    function check() {
      attempts += 1;
      if (consentAllowsRecording()) {
        callback();
        return;
      }
      if (attempts < 20 && state.consentState === "privacy_api_unavailable") {
        window.setTimeout(check, 250);
      }
    }

    check();

    document.addEventListener("visitorConsentCollected", function () {
      if (!state.started && consentAllowsRecording()) callback();
    });
  }

  function getContext() {
    return {
      url: window.location.href,
      landing_url: state.landingUrl,
      referrer: document.referrer || "",
      locale: document.documentElement.getAttribute("lang") || navigator.language || "",
      timezone: Intl.DateTimeFormat().resolvedOptions().timeZone || "",
      consent_state: state.consentState,
      viewport: {
        width: window.innerWidth || 0,
        height: window.innerHeight || 0,
        dpr: window.devicePixelRatio || 1
      },
      shop: window.Shopify && window.Shopify.shop,
      theme: window.theme && window.theme.settings ? window.theme.settings.themeName : "unknown"
    };
  }

  function enqueueMarker(type, details) {
    state.markers.push({
      type: type,
      ts: Date.now(),
      details: details || {}
    });
    if (state.markers.length >= 10) flush(false);
  }

  function compactElementInfo(el) {
    if (!el || !el.tagName) return {};
    return {
      tag: String(el.tagName).toLowerCase(),
      id: el.id || "",
      classes: String(el.className || "").slice(0, 160),
      role: el.getAttribute("role") || "",
      name: el.getAttribute("name") || "",
      href: el.href ? String(el.href).slice(0, 500) : "",
      text: String(el.innerText || el.textContent || "").replace(/\s+/g, " ").trim().slice(0, 120)
    };
  }

  function installBusinessMarkers() {
    document.addEventListener("click", function (event) {
      var target = event.target && event.target.closest ? event.target.closest("a,button,[role='button'],input[type='submit']") : null;
      if (!target) return;
      var info = compactElementInfo(target);
      var label = (info.text + " " + info.classes + " " + info.href).toLowerCase();
      if (label.indexOf("add-to-cart") !== -1 || target.hasAttribute("data-add-to-cart")) {
        enqueueMarker("add_to_cart_click", info);
      } else if (label.indexOf("checkout") !== -1 || target.name === "checkout") {
        enqueueMarker("checkout_click", info);
      } else if (label.indexOf("cart") !== -1 || label.indexOf("warenkorb") !== -1) {
        enqueueMarker("cart_click", info);
      }
    }, true);

    document.addEventListener("submit", function (event) {
      enqueueMarker("form_submit", compactElementInfo(event.target));
    }, true);

    document.addEventListener("visibilitychange", function () {
      enqueueMarker("visibility_" + document.visibilityState, { url: window.location.href });
      if (document.visibilityState === "hidden") flush(true);
    });

    window.addEventListener("popstate", function () {
      enqueueMarker("history_popstate", { url: window.location.href });
    });
  }

  function sendPayload(payload, keepalive) {
    var body = JSON.stringify(payload);
    if (keepalive && navigator.sendBeacon) {
      try {
        var blob = new Blob([body], { type: "application/json" });
        if (navigator.sendBeacon(CONFIG.endpoint, blob)) return;
      } catch (err) {
        log("magie session replay beacon failed", err);
      }
    }
    fetch(CONFIG.endpoint, {
      method: "POST",
      mode: "cors",
      credentials: "omit",
      keepalive: Boolean(keepalive),
      headers: { "Content-Type": "application/json" },
      body: body
    }).catch(function (err) {
      log("magie session replay post failed", err);
    });
  }

  function flush(keepalive) {
    if (!state.events.length && !state.markers.length) return;
    var events = state.events.splice(0, CONFIG.maxEventsPerBatch);
    var markers = state.markers.splice(0, 100);
    sendPayload({
      session_id: state.sessionId,
      batch_index: state.batchIndex++,
      url: window.location.href,
      landing_url: state.landingUrl,
      events: events,
      markers: markers,
      context: getContext()
    }, keepalive);
  }

  function startRecorder() {
    if (state.started) return;
    if (Math.random() > CONFIG.sampleRate) return;
    state.started = true;
    loadScript(CONFIG.rrwebUrl, function () {
      if (!window.rrweb || typeof window.rrweb.record !== "function") return;
      installBusinessMarkers();
      enqueueMarker("session_start", { path: window.location.pathname });
      state.stopRecording = window.rrweb.record({
        emit: function (event) {
          state.events.push(event);
          if (state.events.length >= CONFIG.flushEveryEvents) flush(false);
        },
        maskAllInputs: true,
        maskInputOptions: {
          color: false,
          date: true,
          "datetime-local": true,
          email: true,
          month: true,
          number: true,
          password: true,
          radio: false,
          range: false,
          search: true,
          select: false,
          tel: true,
          text: true,
          textarea: true,
          time: true,
          url: true,
          week: true
        },
        blockClass: "magie-sr-block",
        maskTextClass: "magie-sr-mask",
        collectFonts: false,
        recordCanvas: false,
        sampling: {
          mousemove: 80,
          mouseInteraction: true,
          scroll: 80,
          media: 500,
          input: "last"
        }
      });
      window.setInterval(function () { flush(false); }, CONFIG.flushEveryMs);
      window.addEventListener("pagehide", function () { flush(true); });
      window.addEventListener("beforeunload", function () { flush(true); });
    });
  }

  waitForConsent(startRecorder);
})();
